<div [hidden]="desabilitar()">
  <a mat-button
    class="visualizador-botao-sem-espaco cinza"
    matTooltip='Visualizar arquivo'
    matTooltipPosition="above"
    (click)="visualizar()"
    >
     <mat-icon>search</mat-icon>
  </a>
</div>
